export const DashboardMenu = {
  labelLogout: 'Sair',
  labelOrders: 'Pedidos em Curso',
  labelCompletedOrders: 'Pedidos Entregues',
  labelOrdersEDF: 'Pedidos EDF',
  labelOrdersEDD: 'Pedidos EDD',
  labelAdmin: 'Administração',
  labelIncidences: 'Incidências'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/DashboardMenu.js